/* global $ */
/*
import Map from "@aobtravel/falco-webkit/src/components/molecules/map/map";
import { newComponent } from "@aobtravel/falco-webkit/src/support";

(function () {
    "use strict";

    if (document.getElementById("addressmap")) {
        $(document).ready(() => {
            const mapTarget = document.getElementById("addressmap");
            newComponent(mapTarget, Map, {});
        });
    }
}());
*/
